import type { FunctionComponent } from 'react';

import type { TextEntity } from './types';

type TextProps = Pick<TextEntity, 'text'>;

export const Text: FunctionComponent<TextProps> = ({ text }) => {
  return <>{text}</>;
};
